<template>
    <UiCard v-if="order && order.id" interactive class="ui-card--preview" @click="open">
        <div class="ui-card__id">
            {{ order.id }}
        </div>
        <div class="ui-card__body py-2">
            <div class="ui-card__primary">
                {{ order.client?.first_name }}
                {{ order.client?.last_name }}
            </div>
            <div class="ui-card__muted">
                {{ dateHumanReadable(order.created_at) }}
            </div>
            <div>
                <UiBadge :type="badgeType" :color="order.status_object?.color">
                    {{ order.status_object?.name }}
                </UiBadge>
            </div>
        </div>
        <div class="ui-card__summary">
            <span class="ui-card__amount">
                {{ order.summary?.totalVat }}
                {{ order.currency_short }}
            </span>
        </div>
    </UiCard>
</template>

<script setup lang="ts">
import { toRef, computed } from 'vue';
import { Order } from '@src/CartOrders/Pages/types';
import { dateHumanReadable } from '@src/Common/Helpers/dates';
import { router } from '@inertiajs/vue3';
import { getColorBadgeType } from '@src/Logging/Pages/helpers';

const props = defineProps<{
    order: Order;
}>();

const order = toRef(props, 'order');

const badgeType = computed(() => getColorBadgeType(order.value.status_color));

const open = (): void => {
    router.visit(route('orders.admin.edit', { id: order.value.id }));
};
</script>
